import _Map from "@babel/runtime-corejs3/core-js-stable/map";
import { PromiseCache } from './promise-cache';

var PromisesCache =
/** @class */
function () {
  /**
   * @param [createPromiseCache] - Caches creator. Use this for customizing caches.
   */
  function PromisesCache(createPromiseCache) {
    if (createPromiseCache === void 0) {
      createPromiseCache = function createPromiseCache() {
        return new PromiseCache();
      };
    }

    this.createPromiseCache = createPromiseCache;
    this.caches = new _Map();
  }

  PromisesCache.prototype.run = function (key, runAction, options) {
    if (!this.caches.has(key)) {
      this.caches.set(key, this.createPromiseCache(key));
    }

    return this.caches.get(key).run(runAction, options);
  };

  PromisesCache.prototype.set = function (key, value) {
    if (!this.caches.has(key)) {
      this.caches.set(key, this.createPromiseCache(key));
    }

    this.caches.get(key).set(value);
  };

  PromisesCache.prototype.reset = function (key) {
    if (arguments.length === 1) {
      this.caches.delete(key);
    }

    this.caches = new _Map();
  };

  return PromisesCache;
}();

export { PromisesCache };
//# sourceMappingURL=promises-cache.js.map